import { iterable, mix } from "@chorda/core";
// type LevelLayoutProps<T> = {
//     tag?: string
//     css?: string
//     weight?: number,
//     atLeft?: Keyed<HtmlBlueprint<T>>
//     atRight?: Keyed<HtmlBlueprint<T>>
//     items?: [HtmlBlueprint<T>, HtmlBlueprint<T>]
// }
export const LevelLayout = (elements, as) => {
    return mix({
        css: 'level',
        templates: {
            left: {
                css: 'level-left',
                defaultComponent: {
                    css: 'level-item',
                    reactions: {
                        level: (v) => {
                            return ({ components: { content: v } });
                        }
                    },
                    injections: {
                        level: (scope) => {
                            //                            console.log(scope)
                            return scope.__it;
                        }
                    }
                },
                reactions: {
                    left: (next) => {
                        //                        console.log(next)
                        return ({ components: next });
                    }
                }
            },
            right: {
                css: 'level-right',
                defaultComponent: {
                    css: 'level-item',
                    reactions: {
                        level: (v) => {
                            //                            console.log(v)
                            return ({ components: { content: v } });
                        }
                    },
                    injections: {
                        level: (s) => {
                            //                            console.log(s)
                            return s.__it;
                        }
                    }
                },
                reactions: {
                    right: (next) => ({ components: next })
                }
            }
        }
    }, as, {
        injections: {
            left: () => iterable(elements[0]),
            right: () => iterable(elements[1])
        },
        // tag: props.tag,
        // css: props.css,
        // weight: props.weight
    });
};
